// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.freemium.RentalManagerUserFreemiumV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  FreemiumChargeRequestDto,
  FreemiumChargeV2ResponseWebDto,
  FreemiumStartPaymentMethodSessionRequestDto,
  FreemiumStartPaymentMethodSessionV2ResponseWebDto,
} from '../..';

export const RentalManagerUserFreemiumV2WebApiHandler_charge_Path = '/api/web/v2/users/freemium/charge';

/**
 * Charge credit card
 */
export const RentalManagerUserFreemiumV2WebApiHandler_charge = (
  postData: FreemiumChargeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, FreemiumChargeRequestDto, FreemiumChargeV2ResponseWebDto>(
    {
      endpoint: RentalManagerUserFreemiumV2WebApiHandler_charge_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Path =
  '/api/web/v2/users/freemium/startPaymentMethodSession';

/**
 * Start payment method session to load the credit card iframe
 */
export const RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession = (
  postData: FreemiumStartPaymentMethodSessionRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    FreemiumStartPaymentMethodSessionRequestDto,
    FreemiumStartPaymentMethodSessionV2ResponseWebDto
  >(
    {
      endpoint: RentalManagerUserFreemiumV2WebApiHandler_startPaymentMethodSession_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
